import { Button, Col, Modal, Radio, Row } from '@oscar/theme';
import { useState } from 'react';
import './styles.scss';

const textOptions = [
  {
    key: 'correctLocation',
    label: 'Removal has been done at the correct location',
  },
  ,
  {
    key: 'correctSize',
    label: 'Removal has been done at the correct size',
  },
  {
    key: 'coveredFromContamination',
    label: 'Exposed insulation has been covered from contaimination',
  },
  {
    key: 'properCondition',
    label: 'Preservation of reuseable insulation material in proper condition',
  },
  {
    key: 'noBulgingOrWetInsulation',
    label: 'No bulging or wet insulation',
  },
  {
    key: 'aluminiumTapeBeingUsed',
    label: 'Aluminium tape being used',
  },
];
interface Props {
  visible: boolean;
  handleCancel: () => void;
  handleSubmit: (actionProps: any) => void;
}

const options = [
  { label: 'Yes', value: true },
  { label: 'No', value: false },
  { label: 'N/A', value: '' },
];
const optionsAccept = [
  { label: 'Accepted', value: true },
  { label: 'Rejected', value: false },
];

export const RemovalChecklist = ({
  visible,
  handleCancel,
  handleSubmit,
}: Props) => {
  const [valuesRadio, setValuesRadio] = useState({
    correctLocation: true,
    correctSize: true,
    coveredFromContamination: true,
    properCondition: true,
    noBulgingOrWetInsulation: true,
    aluminiumTapeBeingUsed: true,
  });
  const [overall, setOverall] = useState({
    overallAcceptance: true,
  });
  const handleOnchangeRaido = (e: any, key: string) => {
    setValuesRadio({
      ...valuesRadio,
      [key]: e.target.value,
    });
  };

  return (
    <div className="removal-checklist">
      <Modal
        closable
        bodyStyle={{ width: '100%' }}
        visible={visible}
        title="Removal Checklist"
        okText="Submit"
        onCancel={handleCancel}
        cancelText="Back"
        footer={[
          <Button onClick={handleCancel}>Back</Button>,
          <Button
            type="primary"
            onClick={() =>
              handleSubmit({
                ...valuesRadio,
                ...overall,
              })
            }
          >
            Submit
          </Button>,
        ]}
        width={600}
      >
        {textOptions.map((item: any) => {
          return (
            <div key={item?.key}>
              <Row className="removal-item" gutter={12}>
                <Col span={12}>
                  <span>{item?.label}</span>
                </Col>
                <Col span={12}>
                  <Radio.Group
                    options={options}
                    defaultValue={true}
                    onChange={(e: any) => handleOnchangeRaido(e, item?.key)}
                  />
                </Col>
              </Row>
            </div>
          );
        })}
        <Row className="removal-acept" gutter={12}>
          <Col span={12}>
            <span>Overall Acceptance</span>
          </Col>
          <Col span={12}>
            <Radio.Group
              options={optionsAccept}
              defaultValue={true}
              onChange={(e: any) =>
                setOverall({ overallAcceptance: e.target.value })
              }
            />
          </Col>
        </Row>
      </Modal>
    </div>
  );
};

export default RemovalChecklist;
